import PrivateImage from './PrivateImage';
import React from 'react';
import CodeBlock from './CodeBlock';

// Shared markdown components for consistent rendering
export const createMarkdownComponents = (openImageModal) => ({
  p: ({ node, ...props }) => (
    <p className="mb-3 last:mb-0 leading-loose" {...props} />
  ),
  a: ({ node, ...props }) => (
    <a
      className="text-blue-600 hover:underline dark:text-blue-400 break-words"
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    />
  ),
  h1: ({ node, ...props }) => (
    <h1
      className="text-2xl font-bold mt-6 mb-3 border-b border-gray-200 dark:border-gray-700 pb-1"
      {...props}
    >
      {props.children}
    </h1>
  ),
  h2: ({ node, ...props }) => (
    <h2 className="text-xl font-semibold mt-5 mb-2" {...props}>
      {props.children}
    </h2>
  ),
  h3: ({ node, ...props }) => (
    <h3 className="text-lg font-medium mt-4 mb-1" {...props}>
      {props.children}
    </h3>
  ),
  h4: ({ node, ...props }) => (
    <h4 className="text-base font-medium mt-3 mb-1" {...props}>
      {props.children}
    </h4>
  ),
  blockquote: ({ node, ...props }) => (
    <blockquote
      className="border-l-4 border-gray-300 dark:border-gray-600 pl-4 italic text-gray-700 dark:text-gray-300 my-3"
      {...props}
    />
  ),
  ul: ({ node, ...props }) => (
    <ul className="list-disc list-outside ml-4 mb-3 space-y-1" {...props} />
  ),
  ol: ({ node, ...props }) => (
    <ol className="list-decimal list-outside ml-4 mb-3 space-y-1" {...props} />
  ),
  li: ({ node, ...props }) => (
    <li className="mb-1 pl-1" {...props} />
  ),
  table: ({ node, ...props }) => (
    <table
      className="border-collapse border border-gray-300 dark:border-gray-600 mt-4 mb-4 w-full text-left"
      {...props}
    />
  ),
  thead: ({ node, ...props }) => (
    <thead className="bg-gray-100 dark:bg-gray-700" {...props} />
  ),
  tr: ({ node, ...props }) => (
    <tr
      className="border border-gray-300 dark:border-gray-600"
      {...props}
    />
  ),
  th: ({ node, ...props }) => (
    <th
      className="border border-gray-300 dark:border-gray-600 px-2 py-1 font-semibold"
      {...props}
    />
  ),
  td: ({ node, ...props }) => (
    <td
      className="border border-gray-300 dark:border-gray-600 px-2 py-1"
      {...props}
    />
  ),
  img: ({ node, src, alt, ...props }) => {
    const handleImageClick = (e) => {
      e.preventDefault();
      openImageModal(e.currentTarget.src, alt, e.target);
    };

    return (
      <PrivateImage
        src={src}
        alt={alt}
        className="max-w-full h-auto rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
        style={{ maxHeight: '400px' }}
        onClick={handleImageClick}
        {...props}
      />
    );
  },
  code: CodeBlock
});